import { lazy } from "react";
import { MODULE_IDS } from "../../../../../../constants/enums";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";

const BusinessG4Sign = Loadable(
  lazy(() =>
    import("./BusinessG4Sign").then(({ BusinessG4Sign }) => ({
      default: BusinessG4Sign,
    }))
  )
);

const BusinessG4SignManageDocument = Loadable(
  lazy(() =>
    import("./BusinessG4SignManageDocument").then(
      ({ BusinessG4SignManageDocument }) => ({
        default: BusinessG4SignManageDocument,
      })
    )
  )
);

export const BusinessG4SignRouter = [
  {
    path: "/business-policy/:customerId/g4-sign/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessG4Sign />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/business-policy/:customerId/g4-sign/:customerPolicyId/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessG4SignManageDocument />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/business-policy/:customerId/g4-sign/:customerPolicyId/manage/:documentCode",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessG4SignManageDocument />
      </AuthorizedRoute>
    ),
  },
];
